import React from 'react'
import Box from '@mui/material/Box';
import ChatBot from './ChatBot';

function TabComponent() {
    return (
        <Box sx={{}}>
            <ChatBot />
        </Box>
    )
}

export default TabComponent